import * as MO from '@effect-ts/morphic'

import { Terms } from './Term/Term'

const Contact_ = MO.make(F =>
  F.interface(
    {
      id: F.number(),
      email: F.nullable(F.string()),
      first_name: F.nullable(F.string()),
      last_name: F.nullable(F.string()),
      name_on_passport: F.nullable(F.string()),
      skype: F.nullable(F.string()),
      whatsapp: F.nullable(F.string()),
      user_id: F.nullable(F.number()),
      is_client: F.boolean(),
      contact_terms: F.nullable(Terms(F)),
      household_name: F.nullable(F.string())
      // TODO: incomplete...
    },
    { name: 'Contact' }
  )
)

export interface Contact extends MO.AType<typeof Contact_> {}
export interface ContactRaw extends MO.EType<typeof Contact_> {}
export const Contact = MO.opaque<ContactRaw, Contact>()(Contact_)

const Contacts_ = MO.make(F => F.array(Contact(F)))
export interface Contacts extends MO.AType<typeof Contacts_> {}
export interface ContactsRaw extends MO.EType<typeof Contacts_> {}
export const Contacts = MO.opaque<ContactsRaw, Contacts>()(Contacts_)
